<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>
                            Tra cứu danh sách thống kê báo cáo đồng bộ
                        </strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source multiple :cached="true" v-model="searchForm.syncSourceTypes" allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Đơn vị:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <!--<template v-if="searchForm.syncSourceTypes != null && searchForm.syncSourceTypes.length == 1">
                                        <unit-tree v-model="searchForm.unitIds" :syncSourceType="searchForm.syncSourceTypes[0]" ref="unitTree" class="no-padding" multiple></unit-tree>
                                    </template>
                                    <template v-else>-->
                                    <top-level-unit :cached="true" v-model="searchForm.unitIds" multiple allowClear="true"></top-level-unit>
                                    <!--</template>-->
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Loại báo cáo:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-if="listGroupReportTypes.length > 0" :options="listGroupReportTypes"
                                             v-model="searchForm.reportTypeGroup"
                                             class="no-padding"
                                             required
                                             style="width:100%"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="Mẫu báo cáo:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 v-if="listReportSyncTypeFilter.length > 0" :options="listReportSyncTypeFilter"
                                             v-model="searchForm.reportTypeIds"
                                             placeholder="--- Tất cả ---"
                                             multiple
                                             allowClear="true"
                                             class="no-padding"
                                             style="width:100%"></select2>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="6">
                                <b-form-group label="Ngày đồng bộ từ:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.startSyncDate" class="no-padding" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>
                                
                                <b-form-group label="Ngày báo cáo từ:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.startDate" placeholder="dd/mm/yyyy" style="width:100%"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col md="6">
                                <b-form-group label="đến:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.endSyncDate" class="no-padding" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                                <b-form-group label="đến:"
                                              label-for="input-name"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker v-model="searchForm.endDate" style="width:100%" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-sm-center">
                            <b-col md="6">
                                <b-form-group label="" :label-cols="4">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            :dynamicFields="gridOptions.fields"
                            :items="reportStats"
                            gridName="Thống kê báo cáo"
                            :showActions="false"
                            ref="reportStatsTable">
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.value) }}
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ReportStats',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    syncSourceTypes: [], //this.getSyncSourceTypeCache() ? [this.getSyncSourceTypeCache()] : [],
                    reportTypeGroup: 1,
                    reportTypeIds: [],
                    startDate: null,
                    endDate: new Date().formatDate(),
                    startSyncDate: null, //new Date().firstDayOfMonth().formatDate(),
                    endSyncDate: new Date().formatDate(),
                    unitIds: [] //this.getTopLevelUnitIdCache() ? [this.getTopLevelUnitIdCache()] : [],
                },
                gridOptions: {
                    fields: [
                        { key: 'unitName', label: 'Tên đơn vị', sortable: true, groupable: true },
                        { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true, groupable: true, groupFormatter: (value, key, item) => this.$store.getters.getSyncSourceType(value) }
                    ]
                },
                reportStats: [],
                loaded: false
            }
        },
        computed: {
            ...mapState({
                listReportSyncTypes: (state, getters) => state.common.listReportSyncTypes,
                listGroupReportTypes: (state, getters) => state.common.listGroupReportTypes,
            }),
            listReportSyncTypeFilter() {
                if (this.searchForm.reportTypeGroup) {
                    var group = this.listGroupReportTypes[this.searchForm.reportTypeGroup - 1];
                    return this.listReportSyncTypes.filter(x => group.reportTypeIds.indexOf(x.id) != -1);
                } else {
                    return this.listReportSyncTypes;
                }
            },
            selectedReportTypes() {
                if (this.searchForm.reportTypeIds == null || this.searchForm.reportTypeIds.length == 0) {
                    return this.listReportSyncTypeFilter;
                } else {
                    return this.listReportSyncTypeFilter.filter(x => this.searchForm.reportTypeIds.indexOf(x.id.toString()) != -1);
                }
            }
        },
        created() {
            this.search();
        },
        mounted() {
        },
        methods: {
            search() {
                var vm = this;
                this.$services.get('data/reports/stats', this.searchForm).done((data) => {
                    //var fields = [
                    //    { key: 'unitName', label: 'Tên đơn vị', sortable: true, groupable: true },
                    //    { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true, groupable: true, groupFormatter: (value, key, item) => this.$store.getters.getSyncSourceType(value) }];

                    var fields = [];

                    vm.selectedReportTypes.forEach((item) => {
                        fields.push({ key: `_RPT_${item.id}`, label: item.shortName ?? item.title, sortable: true });
                    });

                    //vm.dynamicFields = fields;
                    var gridFields = vm.$refs.reportStatsTable.options.fields;
                    while (gridFields.length > 0 && gridFields[gridFields.length - 1].key.indexOf('_RPT_') == 0) {
                        gridFields.pop();
                    }

                    vm.$refs.reportStatsTable.options.fields = gridFields.concat(fields);

                    vm.reportStats = data;
                });
            }
        }
    }
</script>
<style scoped>
</style>
